(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationTypeDetailController', CommunicationTypeDetailController);

    CommunicationTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationType'];

    function CommunicationTypeDetailController($scope, $rootScope, $stateParams, entity, CommunicationType) {
        var vm = this;
        vm.communicationType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:communicationTypeUpdate', function(event, result) {
            vm.communicationType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
